/* tslint:disable */
/* eslint-disable */
/**
 * ITA_Rooming_Scaffold
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountResult
 */
export interface CountResult {
    /**
     * 
     * @type {string}
     * @memberof CountResult
     */
    countType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CountResult
     */
    countResult?: number;
}

export function CountResultFromJSON(json: any): CountResult {
    return CountResultFromJSONTyped(json, false);
}

export function CountResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countType': !exists(json, 'countType') ? undefined : json['countType'],
        'countResult': !exists(json, 'countResult') ? undefined : json['countResult'],
    };
}

export function CountResultToJSON(value?: CountResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countType': value.countType,
        'countResult': value.countResult,
    };
}


